/**
 * Guest Landing Page
 * Shown to anyone who opens the game with no way in on its URL (no ?mode=),
 * local development included. The game's name is the headline, so the brand
 * along the top is the plane mark alone; the card says why there is nothing
 * to join here — players come from their session in the portal — beside the
 * lock in the neutral mark. Nothing to press, so no gold; the language is the
 * one control, unless the link names one.
 */

import { useTranslation } from 'react-i18next';

import { GLYPH } from '../ui/glyphs';
import { EntryCard, EntryHead } from './entry-card';
import { EntryFrame } from './entry-frame';

export function GuestLandingPage({ search }: { search: string }) {
  const { t } = useTranslation();

  return (
    <EntryFrame search={search} brand="mark" title={t('login.title')} meaning={t('login.subtitle')}>
      <EntryCard>
        <EntryHead glyph={GLYPH.lock} tone="neutral" title={t('guestLanding.inviteOnly')}>
          {t('guestLanding.inviteHint')}
        </EntryHead>
      </EntryCard>
    </EntryFrame>
  );
}
